import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ToastsContainer } from '../../components/toastsContainer';
import { useAppSelector } from '../../redux/store';
import { assertUnreachable } from '../../utils/tsUtils';
import { ReverifyAskPage } from './reverifyAskPage';
import { ReverifyCurrentEmailVerificationSentPage } from './reverifyCurrentEmailVerificationSentPage';
import { ReverifyNewEmailVerificationSentPage } from './reverifyNewEmailVerificationSentPage';
import { ReverifyUpdateEmailFormPage } from './reverifyUpdateEmailFormPage';
export const ReverifyScene = () => {
    const reverifyPage = useAppSelector((state) => state.reverify.page);
    const getContents = () => {
        if (!reverifyPage) {
            return null;
        }
        switch (reverifyPage) {
            case 'ask': {
                return _jsx(ReverifyAskPage, {});
            }
            case 'current-email-verification-sent': {
                return _jsx(ReverifyCurrentEmailVerificationSentPage, {});
            }
            case 'update-email': {
                return _jsx(ReverifyUpdateEmailFormPage, {});
            }
            case 'new-email-verification-sent': {
                return _jsx(ReverifyNewEmailVerificationSentPage, {});
            }
            default: {
                assertUnreachable(reverifyPage);
            }
        }
    };
    return (_jsxs(_Fragment, { children: [getContents(), _jsx(ToastsContainer, {})] }));
};
